// src/theme.js
import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: `'Poppins', sans-serif`,
    body: `'Poppins', sans-serif`,
  },
fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem",
  },  
 lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    "3": ".75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "7": "1.75rem",
    "8": "2rem",
    "9": "2.25rem",
    "10": "2.5rem",
  },
breakpoints:{
  base: '0em',
  sm: '30em', //30 x 16px = 480 px
  md: '48em', // 768
  lg: '62em', // 992
  xl: '80em', // 1280
  '2xl': '96em', //1536
  },  
  sizes: {
    max: 'max-content',
    min: 'min-content',
    full: '100%',
    '3xs': '14rem',
    '2xs': '16rem',
    xs: '20rem',
    sm: '24rem',
    md: '28rem',
    lg: '32rem',
    xl: '36rem',
    '2xl': '42rem',
    '3xl': '48rem',
    '4xl': '56rem',
    '5xl': '64rem',
    '6xl': '72rem',
    '7xl': '80rem',
    '8xl': '90rem',
    container: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
    }, 
  },  
  styles: {
    global: {
      "*": {
        boxSizing: "border-box",
        padding: 0,
        margin: 0,
        scrollBehavior: "smooth",
      },
      "html, body, #root": {
        height: "100%",
      },
      a: {
        textDecoration: "none",
        color: "inherit", // optional: übernimmt Textfarbe aus Kontext
        _hover: {
          textDecoration: "none", // bleibt ohne Unterstrich beim Hover
        },
      },
    },
  },
  colors: {
    accent: {
      500: "#ff914d",
    },
    text: {
      900: "#222831",
    },
    gradientBarStart: "#01546f",
    gradientBarEnd: "#0083b0",
  },

  components: {
    Button: {
      baseStyle: {
        fontWeight: "600",
        borderRadius: "md",
      },
      variants: {
        primary: (props) => ({
          bgGradient: `linear(89.97deg, ${props.theme.colors.gradientBarStart} 1.84%, ${props.theme.colors.gradientBarEnd} 102.67%)`,
          color: "white",
          _hover: { filter: "brightness(0.95)" },
          boxShadow: "sm",
        }),
        subtleAccent: {
          bg: "accent.500",
          color: "white",
          _hover: { bg: "orange.400" },
        },
        danger: {
          bg: "red.600",
          color: "white",
          _hover: { bg: "red.500" },
        },
        ghostOutline: {
          bg: "transparent",
          border: "1px solid",
          borderColor: "gray.200",
          color: "text.900",
          _hover: { bg: "gray.50" },
        },
      },
      defaultProps: {
        variant: "primary",
      },
    },
    Heading: {
      baseStyle: {
        fontFamily: `'Poppins', sans-serif`,
      },
    },
    Input: {
      baseStyle: {
        field: {
          borderRadius: "md",
        },
      },
    },
  },
});

export default theme;

